import { useCampaignSlug } from '@/lib/useCampaignSlug'
import { convertLanguage } from '@/lib/useChangeLanguage'

interface Headers {
  Accept: 'application/json'
  'Content-Type': 'application/json'
  'X-Raund-Token': string
  'X-Local': string
  'X-Raund-Campaign': string
  [key: string]: string
}
interface HeadersWithAuthorization extends Headers {
  'X-Authorization': string
}

/**
 * headers: Authorizationなしのヘッダー
 * headersWithAuthorization: Authorizationありのヘッダー
 */
export const useCampaignHeaders = (): { headers: Headers; headersWithAuthorization: HeadersWithAuthorization } => {
  const { LOCAL_STORAGE_I18N_KEY, LOCAL_STORAGE_JWT_KEY, campaignSlug } = useCampaignSlug()
  const detectedLng = convertLanguage(navigator.language)
  if (typeof window === 'undefined') {
    const headers: Headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
      'X-Raund-Campaign': campaignSlug,
      'X-Local': 'ja_JP',
    }

    return {
      headers,
      headersWithAuthorization: {
        ...headers,
        'X-Authorization': '',
      },
    }
  }

  const headers: Headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Raund-Token': `${process.env.NEXT_PUBLIC_RAUND_TOKEN}`,
    'X-Raund-Campaign': campaignSlug,
    'X-Local': localStorage.getItem(LOCAL_STORAGE_I18N_KEY) || detectedLng || 'ja_JP',
  }
  const headersWithAuthorization: HeadersWithAuthorization = {
    ...headers,
    'X-Authorization': localStorage.getItem(LOCAL_STORAGE_JWT_KEY) || '',
  }
  return { headers, headersWithAuthorization }
}
